import React from "react";
import Header from "../components/Header";
import { Container } from "../styles/Container.styled";
import styled from "styled-components";
import { Head } from "../components/Head";
import "../styles/main.css";

const Terms = () => {
	return (
		<>
			<Head titleSuffix={"Terms of Service"} />
			<Header pageTilte={"Terms of Service"} />
			<ContentContainer>
				<Content>
					<p>
						<strong>Welcome to Witz!</strong>
					</p>
					<br />
					<p>
						Thank you for signing up to use our products, including the Witz
						application(the “Witz Platform”), website (the “Site”), and
						services, features, content, applications and widgets offered on the
						Witz Platform and Site (together, we’ll call these the “Services”).
						The Services are provided by Swipr Corporation. The term “you” or
						“User” refers to the person or entity accessing or otherwise using
						our Services.
					</p>
					<br />
					<p>
						These Terms of Service (or “Terms” for short) describe the rules of
						Witz’s relationship with you and apply to your use of the Services.
						They are a legal agreement, so please read them carefully.
					</p>
					<br />
					<p>
						By registering for and/or using the Services in any manner, you
						agree to all of the terms and conditions contained in these Terms,
						which also incorporate Witz’s Privacy Policy and all other operating
						rules, policies and procedures that may be published from time to
						time on the Witz Platform by Witz, each of which may be updated by
						Witz from time to time without notice to you in accordance with the
						terms set out under the “Updates to These Terms” section below. In
						addition, some services offered through the Services may be subject
						to additional terms and conditions specified by Witz from time to
						time; your use of such services is subject to those additional terms
						and conditions, which are incorporated into these Terms by
						reference. These Terms apply to all users of the Services,
						including, without limitation, users who are contributors of
						content, information, and other materials or services on the Site,
						individual users of the Services, venues that access the Services,
						and users that have a page on the Services. IF YOU DO NOT AGREE WITH
						THESE TERMS, PLEASE DO NOT USE THESE SERVICES.
					</p>
					<br />
					<h3>I. Acceptance of the Present Terms & Conditions</h3>
					<br />
					<p>
						By registering or using Witz on the mobile application or website
						(collectively, the “Service”), you acknowledge that the use of the
						Service is subject to Witz’s Terms of Service (“TOS”) which you must
						accept in order to use our Service. Furthermore, the use of our
						Service means that you also agree to our Privacy Policy and our
						Guidelines.
					</p>
					<br />
					<h3>II. Changes to the Terms</h3>
					<br />
					<p>
						We amend these Terms from time to time. We may do this for a variety
						of reasons including to reflect changes in or requirements of the
						law, new features, or changes in business practices. The most recent
						version of this Agreement will be posted within the Witz app within
						Settings and also on the website, and you should regularly check for
						the most recent version. The most recent version is the version that
						applies. If the changes include material changes that affect your
						rights or obligations, we will notify you in advance of the changes
						by reasonable means, which could include notification through the
						Witz app. If you continue to use the Service after the changes
						become effective, then you agree to the revised Agreement. You agree
						that this Agreement shall supersede any prior agreements (except as
						specifically stated herein), and shall govern your entire
						relationship with Witz, including but not limited to events,
						agreements, and conduct preceding your acceptance of this Agreement.
					</p>
					<br />
					<h3>III. Our Services</h3>
					<br />
					<p>
						The information provided when using the Services is not intended for
						distribution to or use by any person or entity in any jurisdiction
						or country where such distribution or use would be contrary to law
						or regulation or which would subject us to any registration
						requirement within such jurisdiction or country. Accordingly, those
						persons who choose to access the Services from other locations do so
						on their own initiative and are solely responsible for compliance
						with local laws, if and to the extent local laws are applicable.
					</p>
					<br />
					<p>
						The Services are not tailored to comply with industry-specific
						regulations (Health Insurance Portability and Accountability Act
						(HIPAA), Federal Information Security Management Act (FISMA), etc.),
						so if your interactions would be subjected to such laws, you may not
						use the Services. You may not use the Services in a way that would
						violate the Gramm-Leach-Bliley Act (GLBA).
					</p>
					<br />
					<h3>IV. Intellectual Property Rights</h3>
					<br />
					<h4>Our intellectual property</h4>
					<p>
						We are the owner or the licensee of all intellectual property rights
						in our Services, including all source code, databases,
						functionality, software, website designs, audio, video, text,
						photographs, and graphics in the Services (collectively, the
						"Content"), as well as the trademarks, service marks, and logos
						contained therein (the "Marks").
					</p>
					<br />
					<p>
						Our Content and Marks are protected by copyright and trademark laws
						(and various other intellectual property rights and unfair
						competition laws) and treaties in the United States and around the
						world.
					</p>
					<br />
					<p>
						The Content and Marks are provided in or through the Services "AS
						IS" for your personal, non-commercial use only.
					</p>
					<br />
					<h4>Your use of our Services</h4>
					<p>
						Subject to your compliance with these Legal Terms, we grant you a
						non-exclusive, non-transferable, revocable license to:
					</p>
					<ul>
						<li>access the Services; and</li>
						<br />
						<li>
							download or print a copy of any portion of the Content to which
							you have properly gained access.
						</li>
					</ul>
					<p>solely for your personal, non-commercial use.</p>
					<br />
					<p>
						Except as set out in this section or elsewhere in our Legal Terms,
						no part of the Services and no Content or Marks may be copied,
						reproduced, aggregated, republished, uploaded, posted, publicly
						displayed, encoded, translated, transmitted, distributed, sold,
						licensed, or otherwise exploited for any commercial purpose
						whatsoever, without our express prior written permission.
					</p>
					<br />
					<p>
						If you wish to make any use of the Services, Content, or Marks other
						than as set out in this section or elsewhere in our Legal Terms,
						please address your request to: witz-support@swipr.cc. If we ever
						grant you permission to post, reproduce, or publicly display any
						part of our Services or Content, you must identify us as the owners
						or licensors of the Services, Content, or Marks and ensure that any
						copyright or proprietary notice appears or is visible on posting,
						reproducing, or displaying our Content.
					</p>
					<br />
					<p>
						We reserve all rights not expressly granted to you in and to the
						Services, Content, and Marks.
					</p>
					<br />
					<p>
						Any breach of these Intellectual Property Rights will constitute a
						material breach of our Legal Terms and your right to use our
						Services will terminate immediately.
					</p>
					<br />
					<h4>Your submissions and contributions</h4>
					<p>
						<strong>Submissions:</strong> By directly sending us any question,
						comment, suggestion, idea, feedback, or other information about the
						Services ("Submissions"), you agree to assign to us all intellectual
						property rights in such Submission. You agree that we shall own this
						Submission and be entitled to its unrestricted use and dissemination
						for any lawful purpose, commercial or otherwise, without
						acknowledgment or compensation to you.
					</p>
					<br />
					<p>
						<strong>Contributions:</strong> The Services may invite you to chat,
						contribute to, or participate in blogs, message boards, online
						forums, and other functionality during which you may create, submit,
						post, display, transmit, publish, distribute, or broadcast content
						and materials to us or through the Services, including but not
						limited to text, writings, video, audio, photographs, music,
						graphics, comments, reviews, rating suggestions, personal
						information, or other material ("Contributions"). Any Submission
						that is publicly posted shall also be treated as a Contribution.
					</p>
					<br />
					<p>
						You understand that Contributions may be viewable by other users of
						the Services and possibly through third-party websites.
					</p>
					<br />
					<p>
						<strong>
							When you post Contributions, you grant us a license (including use
							of your name, trademarks, and logos):
						</strong>{" "}
						By posting any Contributions, you grant us an unrestricted,
						unlimited, irrevocable, perpetual, non-exclusive, transferable,
						royalty-free, fully-paid, worldwide right, and license to: use,
						copy, reproduce, distribute, sell, resell, publish, broadcast,
						retitle, store, publicly perform, publicly display, reformat,
						translate, excerpt (in whole or in part), and exploit your
						Contributions (including, without limitation, your image, name, and
						voice) for any purpose, commercial, advertising, or otherwise, to
						prepare derivative works of, or incorporate into other works, your
						Contributions, and to sublicense the licenses granted in this
						section. Our use and distribution may occur in any media formats and
						through any media channels.
					</p>
					<br />
					<p>
						This license includes our use of your name, company name, and
						franchise name, as applicable, and any of the trademarks, service
						marks, trade names, logos, and personal and commercial images you
						provide.
					</p>
					<br />
					<p>
						You are responsible for what you post or upload: By sending us
						Submissions and/or posting Contributions through any part of the
						Services or making Contributions accessible through the Services by
						linking your account through the Services to any of your social
						networking accounts, you:
					</p>
					<br />
					<ul>
						<li>
							confirm that you will not post, send, publish, upload, or transmit
							through the Services any Submission nor post any Contribution that
							is illegal, harassing, hateful, harmful, defamatory, obscene,
							bullying, abusive, discriminatory, threatening to any person or
							group, sexually explicit, false, inaccurate, deceitful, or
							misleading;
						</li>
						<br />
						<li>
							to the extent permissible by applicable law, waive any and all
							moral rights to any such Submission and/or Contribution;
						</li>
						<br />
						<li>
							warrant that any such Submission and/or Contributions are original
							to you or that you have the necessary rights and licenses to
							submit such Submissions and/or Contributions and that you have
							full authority to grant us the above-mentioned rights in relation
							to your Submissions and/or Contributions; and
						</li>
						<br />
						<li>
							warrant and represent that your Submissions and/or Contributions
							do not constitute confidential information.
						</li>
						<br />
					</ul>
					<p>
						You are solely responsible for your Submissions and/or Contributions
						and you expressly agree to reimburse us for any and all losses that
						we may suffer because of your breach of (a) this section, (b) any
						third party’s intellectual property rights, or (c) applicable law.
					</p>
					<br />
					<p>
						<strong>We may remove or edit your Content:</strong> Although we
						have no obligation to monitor any Contributions, we shall have the
						right to remove or edit any Contributions at any time without notice
						if in our reasonable opinion we consider such Contributions harmful
						or in breach of these Legal Terms. If we remove or edit any such
						Contributions, we may also suspend or disable your account and
						report you to the authorities.
					</p>
					<br />
					<h3>V. Who Can Use the Services</h3>
					<br />
					<p>
						You must be at least 18 years of age to use the Service. By using
						the Service, you represent and warrant that:
					</p>
					<ul>
						<li>
							You have the legal capacity and you agree to comply with these
							Legal Terms.
						</li>
						<br />
						<li>
							You are not a minor in the jurisdiction in which you reside.
						</li>
						<br />
						<li>
							You are not a person who is barred from receiving the Service
							under the laws of the United States or any other applicable
							jurisdiction.
						</li>
						<br />
						<li>
							You will not access the Services through automated or non-human
							means, whether through a bot, script, or otherwise.
						</li>
						<br />
						<li>
							You will not use the Services for any illegal or unauthorized
							purpose.
						</li>
						<br />
						<li>
							You have never been convicted of or pled no contest to a felony, a
							sex crime, or any crime involving violence, and you are not
							required to register as a sex offender with any state, federal, or
							local sex offender registry.
						</li>
						<br />
						<li>
							You will comply with this Agreement and all applicable local,
							state, national, and international laws, rules, and regulations.
						</li>
						<br />
					</ul>
					<p>
						If you provide any information that is untrue, inaccurate, not
						current, or incomplete, we have the right to suspend or terminate
						your account and refuse all current or future use of the Services
						(or any portion thereof).
					</p>
					<br />
					<h3>VI. Rights Witz Grants You</h3>
					<br />
					<p>
						Witz grants you a personal, worldwide, royalty-free, non-assignable,
						nonexclusive, revocable, and non-sublicensable license to access and
						use the Service. This license is for the sole purpose of letting you
						use and enjoy the Service’s benefits as intended by Witz and
						permitted by this Agreement. Therefore, you agree not to:
					</p>
					<ul>
						<li>
							Use the Service or any content contained in the Service for any
							commercial purposes without our written consent; you have
							permission to mention our Service on user-generated content
							platforms such as Youtube and TikTok as long as you don’t claim
							that Witz endorses your content.
						</li>
						<br />
						<li>
							Copy, modify, transmit, create any derivative works from, make use
							of, or reproduce in any way any copyrighted material, images,
							trademarks, trade names, service marks, or other intellectual
							property, content or proprietary information accessible through
							the Service without Witz’s prior written consent.
						</li>
						<br />
						<li>
							Express or imply that any statements you make are endorsed by
							Witz.
						</li>
						<br />
						<li>
							Use any robot, bot, spider, crawler, scraper, site
							search/retrieval application, proxy or other manual or automatic
							device, method or process to access, retrieve, index, “data mine,”
							or in any way reproduce or circumvent the navigational structure
							or presentation of the Service or its contents.
						</li>
						<br />
						<li>
							Use the Service in any way that could interfere with, disrupt or
							negatively affect the Service or the servers or networks connected
							to the Service.
						</li>
						<br />
						<li>
							Upload viruses or other malicious code or otherwise compromise the
							security of the Service.
						</li>
						<br />
						<li>
							Forge headers or otherwise manipulate identifiers in order to
							disguise the origin of any information transmitted to or through
							the Service.
						</li>
						<br />
						<li>
							“Frame” or “mirror” any part of the Service without Witz’s prior
							written authorization.
						</li>
						<br />
						<li>
							Use meta tags or code or other devices containing any reference to
							Witz or the Service (or any trademark, trade name, service mark,
							logo or slogan of Witz) to direct any person to any other website
							for any purpose.
						</li>
						<br />
						<li>
							Modify, adapt, sublicense, translate, sell, reverse engineer,
							decipher, decompile or otherwise disassemble any portion of the
							Service, or cause others to do so.
						</li>
						<br />
						<li>
							Use or develop any third-party applications that interact with the
							Service or other users’ Content or information without our written
							consent.
						</li>
						<br />
						<li>
							use, access, or publish the Witz application programming interface
							without our written consent.
						</li>
						<br />
						<li>
							Probe, scan or test the vulnerability of our Service or any system
							or network.
						</li>
						<br />
						<li>
							Encourage or promote any activity that violates this Agreement.
						</li>
						<br />
						<li>
							Witz may investigate and take any available legal action in
							response to illegal and/ or unauthorized uses of the Service,
							including termination of your account.
						</li>
						<br />
						<li>
							Any software that we provide you may automatically download and
							install upgrades, updates, or other new features. You may be able
							to adjust these automatic downloads through your device’s
							settings.
						</li>
						<br />
					</ul>
					<br />
					<h3>VII. Rights You Grant Us</h3>
					<br />
					<p>
						Many of our Services let you create, upload, post, send, receive,
						and store content. When you do that, you retain whatever ownership
						rights in that content you had to begin with. But you grant us a
						license to use that content. While we’re not required to do so, we
						may access, review, screen, and delete your content at any time and
						for any reason, including to provide and develop the Service or if
						we think your content violates these Terms. You alone, though,
						remain responsible for the content you create, upload, post, send,
						or store through the Service. We always love to hear from our users.
						But if you provide feedback or suggestions, just know that we can
						use them without compensating you, and without any restriction or
						obligation to you.
					</p>
					<br />
					<h3>VIII. User Generated Content</h3>
					<br />
					<p>
						Much of the content on our Service is produced by users and other
						third parties. Whether that content is posted publicly or sent
						privately, the content is the sole responsibility of the person or
						organization that submitted it. Although Witz reserves the right to
						review or remove all content that appears on the Service, we do not
						necessarily review all of it. So we cannot—and do not—take
						responsibility for any content that others provide through the
						Services. Through these Terms, we make clear that we do not want the
						Service put to bad use. But because we do not review all content, we
						cannot guarantee that content on the Services will always conform to
						our Terms. If you have any concerns or want to report any concerning
						content, please promptly contact us at witz-support@swipr.cc or use
						the reporting feature within the Witz mobile application.
					</p>
					<br />
					<h3>IX. Rules of Conduct</h3>
					<br />
					<p>
						Safety of our users is of utmost importance for us. As a result, we
						have laid out the following Rules of Conduct which every user is
						subject to, whether they have an account or not. You are solely
						responsible for everything you write, post, upload, or make public.
						Furthermore, by using our Service, you also agree to our Community
						Guidelines. If you are using our Services, you are not allowed to
						send, upload, or post anything which:
					</p>
					<ul>
						<li>Could potentially cause any harm or damage to anyone</li>
						<br />
						<li>
							Is mean, is bullying someone or is intended to harass, scare or
							upset anyone
						</li>
						<br />
						<li>
							Is deliberately designed to provoke or antagonize people,
							especially trolling
						</li>
						<br />
						<li>Uses rude or profane language</li>
						<br />
						<li>Encourages dangerous or illegal activities</li>
						<br />
						<li>Encourages any type of self-harm</li>
						<br />
						<li>Contains any obscene or pornographic content</li>
						<br />
						<li>
							Contains any threat of any kind, including threats to yourself or
							others
						</li>
						<br />
						<li>
							Is racist or discriminates based on someone’s race, religion, age,
							gender, disability, or sexuality
						</li>
						<br />
						<li>Infringes on individual’s privacy rights</li>
						<br />
						<li>Competes with our Service or is spam</li>
						<br />
						<li>
							Is illegal, could expose Witz to legal liability, or encourages
							people to get involved in anything which is illegal (for example,
							drugs, violence, or crime)
						</li>
						<br />
						<li>
							Is defamatory or violates any third party’s rights, including
							breach of confidence, copyright, trademark, patent, trade secret,
							moral right, privacy right, right of publicity, or any other
							intellectual property right.
						</li>
						<br />
						<li>
							Collects user content or information, or otherwise accesses the
							Services using automated means (such as harvesting bots, robots,
							spiders, or scrapers) without our prior permission
						</li>
						<br />
						<li>
							Violates any robot exclusion headers of the site, if any, or
							bypasses or circumvents other measures employed to prevent or
							limit access to Services
						</li>
						<br />
						<li>
							Shares, recompiles, decompiles, disassembles, reverse engineers,
							or makes or distributes any other form of, or any derivative work
							from, the Service
						</li>
						<br />
						<li>
							Attempts to scrape or collect any personal or private information
							from other users or from the Service
						</li>
						<br />
						<li>
							Pretends to come from someone other than you, or where you are
							impersonating someone else
						</li>
						<br />
						<li>
							Intercepts or monitors, damages, or modifies any communication not
							intended for you
						</li>
						<br />
						<li>Otherwise breaches the Terms of Service</li>
						<br />
					</ul>
					<p>
						Witz does not tolerate ANY objectionable content or abusive users.
						Any objectionable content posted on Witz will be reviewed by our
						Content Safety team. We reserve the right to take down any
						objectionable content immediately without any notice.
					</p>
					<br />
					<h3>X. Privacy</h3>
					<br />
					<p>
						Your privacy matters to us. By reading our Privacy Policy, you can
						learn how we handle your information when you use our Service. We
						encourage you to give the Privacy Policy a careful look because, by
						using our Service, you agree that Witz can collect, use, and share
						your information consistent with that policy. Please note that Witz
						may ask for permission to collect and store on our servers your
						personal information such as Contacts on your phone. We cannot and
						do not collect information unless you give us explicit permission to
						do so. While we collect information (such as your Contacts) to help
						you take full advantage of our product features, we understand if
						you feel uncomfortable permitting us. If so, you are encouraged to
						deny permitting us. You also have the ability to delete any
						information you have given us from our servers; for example, if you
						have given us permission to your Contacts, but no longer wish to
						have them stored on our servers, let us know at
						witz-support@swipr.cc. You can also delete your account or any other
						information from our servers by reaching us at that email. To
						understand more about how Witz collects, uses, shares, and stores
						your information, please read our Privacy Policy.
					</p>
					<br />
					<h3>XI. Prohibited Activities</h3>
					<br />
					<p>
						You may not access or use the Services for any purpose other than
						that for which we make the Services available. The Services may not
						be used in connection with any commercial endeavors except those
						that are specifically endorsed or approved by us.
					</p>
					<br />
					<p>As a user of the Services, you agree not to:</p>
					<ul>
						<li>
							Systematically retrieve data or other content from the Services to
							create or compile, directly or indirectly, a collection,
							compilation, database, or directory without written permission
							from us.
						</li>
						<br />
						<li>
							Trick, defraud, or mislead us and other users, especially in any
							attempt to learn sensitive account information such as user
							passwords.
						</li>
						<br />
						<li>
							Circumvent, disable, or otherwise interfere with security-related
							features of the Services, including features that prevent or
							restrict the use or copying of any Content or enforce limitations
							on the use of the Services and/or the Content contained therein.
						</li>
						<br />
						<li>
							Disparage, tarnish, or otherwise harm, in our opinion, us and/or
							the Services.
						</li>
						<br />
						<li>
							Use any information obtained from the Services in order to harass,
							abuse, or harm another person.
						</li>
						<br />
						<li>
							Make improper use of our support services or submit false reports
							of abuse or misconduct.
						</li>
						<br />
						<li>
							Use the Services in a manner inconsistent with any applicable laws
							or regulations.
						</li>
						<br />
						<li>
							Engage in unauthorized framing of or linking to the Services.
						</li>
						<br />
						<li>
							Upload or transmit (or attempt to upload or to transmit) viruses,
							Trojan horses, or other material, including excessive use of
							capital letters and spamming (continuous posting of repetitive
							text), that interferes with any party’s uninterrupted use and
							enjoyment of the Services or modifies, impairs, disrupts, alters,
							or interferes with the use, features, functions, operation, or
							maintenance of the Services.
						</li>
						<br />
						<li>
							Engage in any automated use of the system, such as using scripts
							to send comments or messages, or using any data mining, robots, or
							similar data gathering and extraction tools.
						</li>
						<br />
						<li>
							Delete the copyright or other proprietary rights notice from any
							Content.
						</li>
						<br />
						<li>
							Attempt to impersonate another user or person or use the username
							of another user.
						</li>
						<br />
						<li>
							Upload or transmit (or attempt to upload or to transmit) any
							material that acts as a passive or active information collection
							or transmission mechanism, including without limitation, clear
							graphics interchange formats ("gifs"), 1×1 pixels, web bugs,
							cookies, or other similar devices (sometimes referred to as
							"spyware" or "passive collection mechanisms" or "pcms").
						</li>
						<br />
						<li>
							Interfere with, disrupt, or create an undue burden on the Services
							or the networks or services connected to the Services.
						</li>
						<br />
						<li>
							Harass, annoy, intimidate, or threaten any of our employees or
							agents engaged in providing any portion of the Services to you.
						</li>
						<br />
						<li>
							Attempt to bypass any measures of the Services designed to prevent
							or restrict access to the Services, or any portion of the
							Services.
						</li>
						<br />
						<li>
							Copy or adapt the Services' software, including but not limited to
							Flash, PHP, HTML, JavaScript, or other code.
						</li>
						<br />
						<li>
							Except as permitted by applicable law, decipher, decompile,
							disassemble, or reverse engineer any of the software comprising or
							in any way making up a part of the Services.
						</li>
						<br />
						<li>
							Except as may be the result of standard search engine or Internet
							browser usage, use, launch, develop, or distribute any automated
							system, including without limitation, any spider, robot, cheat
							utility, scraper, or offline reader that accesses the Services, or
							use or launch any unauthorized script or other software.
						</li>
						<br />
						<li>
							Use a buying agent or purchasing agent to make purchases on the
							Services.
						</li>
						<br />
						<li>
							Make any unauthorized use of the Services, including collecting
							usernames and/or email addresses of users by electronic or other
							means for the purpose of sending unsolicited email, or creating
							user accounts by automated means or under false pretenses.
						</li>
						<br />
						<li>
							Use the Services as part of any effort to compete with us or
							otherwise use the Services and/or the Content for any
							revenue-generating endeavor or commercial enterprise.
						</li>
						<br />
					</ul>
					<br />
					<h3>XII. Purchases</h3>
					<br />
					<p>
						Generally. From time to time, Witz may offer products and services
						for purchase (“in app purchases”) through iTunes, Google Play, Witz
						direct billing or other payment platforms authorized by Guppir. If
						you choose to make an in-app purchase, you will be prompted to
						confirm your purchase with the applicable payment provider. Your
						method of payment (be it your card or a third-party account such as
						Google Play or iTunes) (your “Payment Method”) will be charged at
						the prices displayed to you for the service(s) you’ve selected as
						well as any sales or similar taxes that may be imposed on your
						payments. You authorize Witz or the third-party account, as
						applicable, to charge you.
					</p>
					<br />
					<p>
						<strong>Auto_Renewal:</strong> If you purchase an auto-recurring
						periodic subscription, your Payment Method will continue to be
						billed for the subscription until you cancel. After your initial
						subscription commitment period, and again after any subsequent
						subscription period, your subscription will automatically continue
						for an additional equivalent period, at the price you agreed to when
						subscribing. If you do not wish your subscription to renew
						automatically, or if you want to change or terminate your
						subscription, you will need to log in to your third-party account
						and follow instructions to cancel your subscription, even if you
						have otherwise deleted your account with us or if you have deleted
						the Witz application from your device. Deleting your account on Witz
						or deleting the Witz application from your device does not cancel
						your subscription; Witz will retain all funds charged to your
						Payment Method until you cancel your subscription on Witz or the
						third-party account, as applicable. If you cancel your subscription,
						you may use your subscription until the end of your then-current
						subscription term, and your subscription will not be renewed after
						your then-current term expires.
					</p>
					<br />
					<p>
						<strong>Virtual Items: </strong>From time to time, you may be able
						to purchase, a limited, personal, non-transferable,
						non-sublicensable, revocable license to use “virtual items,” such as
						1-day pass (collectively, “Virtual Items”). Virtual Items do not
						incur fees for non-use, however, the license granted to you in
						Virtual Items will terminate in accordance with the terms of this
						Agreement, when Witz ceases providing the Service or your account is
						otherwise closed or terminated. Witz, in its sole discretion,
						reserves the right to charge fees for the right to access or use
						Virtual Items and/ or may distribute Virtual Items with or without
						charge. Witz may manage, regulate, control, modify or eliminate
						Virtual Items at any time. Witz shall have no liability to you or
						any third party in the event that Guppir exercises any such rights.
						Virtual Items may only be redeemed through the Service. ALL
						PURCHASES AND REDEMPTIONS OF VIRTUAL ITEMS MADE THROUGH THE SERVICE
						ARE FINAL AND NON-REFUNDABLE. The provision of Virtual Items for use
						in the Service is a service that commences immediately upon the
						acceptance of your purchase of such Virtual Items. YOU ACKNOWLEDGE
						THAT Witz IS NOT REQUIRED TO PROVIDE A REFUND FOR ANY REASON, AND
						THAT YOU WILL NOT RECEIVE MONEY OR OTHER COMPENSATION FOR UNUSED
						VIRTUAL ITEMS WHEN AN ACCOUNT IS CLOSED, WHETHER SUCH CLOSURE WAS
						VOLUNTARY OR INVOLUNTARY.
					</p>
					<br />
					<p>
						<strong>Cancellation:</strong> All purchases are non-refundable. On
						Apple devices by visiting your iCloud subscription settings and
						opting out of subscription renewal. On Google devices by visiting
						your Google account subscription settings and opting out of
						subscription renewal. Please do so at least 24-hours prior to
						subscription renewal to ensure adequate time for Apple/Google to
						process your update. Your cancellation will take effect at the end
						of the current paid term.
					</p>
					<br />
					<p>
						If you are unsatisfied with our Services, please email us at
						witz-support@swipr.cc.
					</p>
					<br />
					<h3>XIII. Copyright</h3>
					<br />
					<p>
						Witz honors copyright laws, including the Digital Millennium
						Copyright Act. We therefore take reasonable steps to expeditiously
						remove from our Service any infringing material that we become aware
						of.
					</p>
					<br />
					<h3>XIV. Third-party Websites and Content</h3>
					<br />
					<p>
						The Services may contain (or you may be sent via the Site or App)
						links to other websites ("Third-Party Websites") as well as
						articles, photographs, text, graphics, pictures, designs, music,
						sound, video, information, applications, software, and other content
						or items belonging to or originating from third parties
						("Third-Party Content"). Such Third-Party Websites and Third-Party
						Content are not investigated, monitored, or checked for accuracy,
						appropriateness, or completeness by us, and we are not responsible
						for any Third-Party Websites accessed through the Services or any
						Third-Party Content posted on, available through, or installed from
						the Services, including the content, accuracy, offensiveness,
						opinions, reliability, privacy practices, or other policies of or
						contained in the Third-Party Websites or the Third-Party Content.
						Inclusion of, linking to, or permitting the use or installation of
						any Third-Party Websites or any Third-Party Content does not imply
						approval or endorsement thereof by us. If you decide to leave the
						Services and access the Third-Party Websites or to use or install
						any Third-Party Content, you do so at your own risk, and you should
						be aware these Legal Terms no longer govern. You should review the
						applicable terms and policies, including privacy and data gathering
						practices, of any website to which you navigate from the Services or
						relating to any applications you use or install from the Services.
						Any purchases you make through Third-Party Websites will be through
						other websites and from other companies, and we take no
						responsibility whatsoever in relation to such purchases which are
						exclusively between you and the applicable third party. You agree
						and acknowledge that we do not endorse the products or services
						offered on Third-Party Websites and you shall hold us blameless from
						any harm caused by your purchase of such products or services.
						Additionally, you shall hold us blameless from any losses sustained
						by you or harm caused to you relating to or resulting in any way
						from any Third-Party Content or any contact with Third-Party
						Websites.
					</p>
					<br />
					<h3>XV. Advertisers</h3>
					<br />
					<p>
						We allow advertisers to display their advertisements and other
						information in certain areas of the Services, such as sidebar
						advertisements or banner advertisements. We simply provide the space
						to place such advertisements, and we have no other relationship with
						advertisers.
					</p>
					<br />
					<h3>XVI. Data Charges</h3>
					<br />
					<p>
						By using the Service on your mobile phone (and/or any other device)
						you may be subject to charges by your Internet or mobile service
						provider, so check with them first if you are not sure, as you will
						be responsible for any such costs.
					</p>
					<br />
					<h3>XVII. Modifying the Service and Termination</h3>
					<br />
					<p>
						Witz is always striving to improve the Service and bring you
						additional functionality that you will find engaging and useful.
						This means we may add new product features or enhancements from time
						to time as well as remove some features, and if these actions do not
						materially affect your rights or obligations, we may not provide you
						with notice before taking them. We may even suspend the Service
						entirely, in which event we will notify you in advance unless
						extenuating circumstances, such as safety or security concerns,
						prevent us from doing so. You may terminate your account at any
						time, for any reason, by contacting us and letting us know you’d
						like to terminate your account. However if you use a third party
						payment account, you will need to manage in app purchases through
						such account (e.g., iTunes, Google Play) to avoid additional
						billing. We reserve the right to terminate your user account at any
						time, including if you have failed to comply with any of the
						provisions of these Terms, or if activities occur on your account
						which, in our sole discretion, would or might cause damage to or
						impair the Services or infringe or violate any third party rights,
						or violate any applicable laws or regulations. Upon such
						termination, you will not be entitled to any refund for purchases.
					</p>
					<br />
					<h3>XVIII. Indemnity</h3>
					<br />
					<p>
						You agree, to the extent permitted by law, to indemnify, defend, and
						hold harmless Witz, our affiliates, directors, officers,
						stockholders, employees, licensors, and agents from and against any
						and all complaints, charges, claims, damages, losses, costs,
						liabilities, and expenses (including attorneys’ fees) due to,
						arising out of, or relating in any way to: (a) your access to or use
						of the Service; (b) your content; and (c) your breach of these
						Terms.
					</p>
					<br />
					<h3>XIX. Disclaimers</h3>
					<br />
					<p>
						WITZ PROVIDES THE SERVICE ON AN “AS IS” AND “AS AVAILABLE” BASIS AND
						TO THE EXTENT PERMITTED BY APPLICABLE LAW, GRANTS NO WARRANTIES OF
						ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE WITH
						RESPECT TO THE SERVICE (INCLUDING ALL CONTENT CONTAINED THEREIN),
						INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF
						SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR
						PURPOSE OR NON-INFRINGEMENT. Guppir DOES NOT REPRESENT OR WARRANT
						THAT (A) THE SERVICE WILL BE UNINTERRUPTED, SECURE OR ERROR FREE,
						(B) ANY DEFECTS OR ERRORS IN THE SERVICE WILL BE CORRECTED, OR (C)
						THAT ANY CONTENT OR INFORMATION YOU OBTAIN ON OR THROUGH THE SERVICE
						WILL BE ACCURATE. WITZ TAKES NO RESPONSIBILITY FOR ANY CONTENT THAT
						YOU OR ANOTHER USER OR THIRD PARTY POSTS, SENDS OR RECEIVES THROUGH
						THE SERVICE. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH
						THE USE OF THE SERVICE IS ACCESSED AT YOUR OWN DISCRETION AND RISK.
						WITZ DISCLAIMS AND TAKES NO RESPONSIBILITY FOR ANY CONDUCT OF YOU OR
						ANY OTHER USER, ON OR OFF THE SERVICE.
					</p>
					<br />
					<h3>XX. Limitation of Liability</h3>

					<p>
						TO THE MAXIMUM EXTENT PERMITTED BY LAW, SWIPR CORPORATION AND OUR
						MANAGING MEMBERS, SHAREHOLDERS, EMPLOYEES, AFFILIATES, LICENSORS,
						AGENTS, AND SUPPLIERS WILL NOT BE LIABLE FOR ANY INDIRECT,
						INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR MULTIPLE DAMAGES,
						OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR
						INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE
						LOSSES, RESULTING FROM: (A) YOUR ACCESS TO OR USE OF OR INABILITY TO
						ACCESS OR USE THE SERVICE; (B) THE CONDUCT OR CONTENT OF OTHER USERS
						OR THIRD PARTIES ON OR THROUGH THE SERVICE; OR (C) UNAUTHORIZED
						ACCESS, USE, OR ALTERATION OF YOUR CONTENT, EVEN IF SWIPR
						CORPORATION HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN
						NO EVENT WILL SWIPR CORPORATION’S AGGREGATE LIABILITY FOR ALL CLAIMS
						RELATING TO THE SERVICES EXCEED THE GREATER OF $100 USD OR THE
						AMOUNT YOU PAID SWIPR CORPORATION, IF ANY, IN THE LAST 12 MONTHS.
					</p>
					<br />
					<h3>XXI. Entire Agreement; Other.</h3>
					<br />
					<p>
						This Agreement, along with the Privacy Policy and any terms
						disclosed to you if you purchase or have purchased additional
						features, products, or services we offer on the Service, contains
						the entire agreement between you and Witz regarding your
						relationship with Witz and the use of the Service. If any provision
						of this Agreement is held invalid, the remainder of this Agreement
						shall continue in full force and effect. The failure of Witz to
						exercise or enforce any right or provision of this Agreement shall
						not constitute a waiver of such right or provision. You agree that
						your Witz account is non-transferable and all of your rights to your
						account and its Content terminate upon your death. No agency,
						partnership, joint venture, fiduciary or other special relationship
						or employment is created as a result of this Agreement and you may
						not make any representations on behalf of or bind Witz in any
						manner.
					</p>
					<br />
					<h3>XXII. Contact Us</h3>
					<br />
					<p>
						Witz welcomes comments, questions, concerns, or suggestions. Please
						contact us at witz-support@swipr.cc
					</p>
					<br />
				</Content>
			</ContentContainer>
		</>
	);
};

const ContentContainer = styled(Container)`
	padding-top: 153px;
	@media (max-width: 768px) {
		width: auto;
	}
`;

const Content = styled.div`
	margin: 50px 0;
	padding-bottom: 80px;
	@media (max-width: 768px) {
		margin: 20px 0;
		font-size: 14px;
		p {
			font-size: 14px;
		}
	}
`;

export default Terms;
